import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { stockService } from "../services/stock";
import { productService } from "../services/product"; // Para buscar nome do produto
import { productionService } from "../services/production"; // Para buscar detalhes do lote de produção
import { formatDateForDisplay } from "../utils/dateUtils";

const StockDetails = () => {
  const [stockEntry, setStockEntry] = useState(null);
  const [productName, setProductName] = useState("");
  const [lotNumber, setLotNumber] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchStockEntry = async () => {
      try {
        setLoading(true);
        const entry = await stockService.getStockEntryById(id);
        setStockEntry(entry);

        // Fetch product name
        if (entry.product_id) {
          const product = await productService.getProductById(entry.product_id);
          setProductName(product.name);
        }

        // Fetch production lot details
        if (entry.production_lot_id) {
          const lot = await productionService.getProductionLotById(
            entry.production_lot_id
          );
          setLotNumber(lot.lot_number);
        }

        setError("");
      } catch (err) {
        setError(
          err.message || "Erro ao carregar detalhes da entrada de stock."
        );
        console.error("Erro ao carregar detalhes da entrada de stock:", err);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchStockEntry();
    }
  }, [id]);

  if (loading) {
    return (
      <div className="min-h-screen bg-neutral-50 flex items-center justify-center">
        <p>A carregar detalhes do stock...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-neutral-50 flex items-center justify-center">
        <div
          className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative"
          role="alert"
        >
          {error}
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-neutral-50 p-8">
      <div className="container mx-auto">
        <h1 className="text-3xl font-bold text-neutral-800 mb-8">
          Detalhes da Entrada de Stock
        </h1>

        {error && (
          <div
            className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-6"
            role="alert"
          >
            {error}
          </div>
        )}

        {stockEntry && (
          <div className="bg-white shadow-md rounded-lg p-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <p className="text-sm text-neutral-600">ID da Entrada:</p>
                <p className="text-lg font-medium text-neutral-900">
                  {stockEntry.id}
                </p>
              </div>
              <div>
                <p className="text-sm text-neutral-600">Produto:</p>
                <p className="text-lg font-medium text-neutral-900">
                  {productName || "A carregar..."}
                </p>
              </div>
              <div>
                <p className="text-sm text-neutral-600">Lote de Produção:</p>
                <p className="text-lg font-medium text-neutral-900">
                  {lotNumber || "A carregar..."} (ID:{" "}
                  {stockEntry.production_lot_id})
                </p>
              </div>
              <div>
                <p className="text-sm text-neutral-600">Quantidade Atual:</p>
                <p className="text-lg font-medium text-neutral-900">
                  {stockEntry.current_quantity} kg/unidades
                </p>
              </div>
              <div>
                <p className="text-sm text-neutral-600">Localização:</p>
                <p className="text-lg font-medium text-neutral-900">
                  {stockEntry.location || "N/A"}
                </p>
              </div>
              <div>
                <p className="text-sm text-neutral-600">Data de Entrada:</p>
                <p className="text-lg font-medium text-neutral-900">
                  {formatDateForDisplay(stockEntry.entry_date)}
                </p>
              </div>
              <div>
                <p className="text-sm text-neutral-600">Última Movimentação:</p>
                <p className="text-lg font-medium text-neutral-900">
                  {formatDateForDisplay(stockEntry.last_movement_date)}
                </p>
              </div>
            </div>
            <div className="mt-8 flex justify-end">
              <button
                onClick={() => navigate(-1)}
                className="bg-neutral-100 text-neutral-900 px-4 py-2 rounded-md hover:bg-neutral-200"
              >
                Voltar para Stock
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default StockDetails;
